<template>
    <rkm-area
        v-if="data.form"
        :subtitle="subtitle"
        :title="title"
    >
        <Form
            :data="data"
            :funcionalidade="funcionalidade"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    computed: {
        title() {
            if (this.funcionalidade === "atendimento-triagem" && this.data.additionals && this.data.additionals.isEnfermeiro) {
                return 'Classificação de risco *';
            } else if (this.funcionalidade === "atendimento-triagem") {
                return 'Classificação de risco';
            } else {
                return 'Classificação de risco *';
            }
        },
        subtitle() {
            if (this.data.form.classificacaoRisco) {
                return this.data.form.classificacaoRisco.dataHora.concat(
                    ' | ',
                    this.data.form.classificacaoRisco.lotacao.profissional.nome
                )
            } else {
                return ''
            }
        }
    },
    props: {
        data: { type: Object, required: true },
        funcionalidade: { type: String, default: null },
    },
}
</script>